/**
 * Capa de Seguridad - Encriptación
 * Proporciona métodos para hashear DNIs usando SHA-256 de forma nativa.
 * Cumple con .idx-rules.md: funciones desacopladas e intención documentada.
 */

/**
 * Genera un hash SHA-256 combinado con la palabra secreta.
 * Razón: anonimizar los documentos de identidad para cumplir con regulaciones de privacidad.
 * @param {string} dni Número de DNI original
 * @param {string} secretWord Sal o palabra clave de cifrado
 * @returns {Promise<string>} Hash hexadecimal de 64 caracteres
 */
export async function hashDNI(dni, secretWord) {
  if (!dni) return '';
  
  // Normalizar entrada
  const cleanDni = dni.trim();
  const cleanSalt = (secretWord || '').trim();
  const message = cleanDni + cleanSalt;

  // Codificar el texto a bytes
  const msgBuffer = new TextEncoder().encode(message);
  
  // Calcular el hash SHA-256 utilizando la API criptográfica nativa del navegador
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  
  // Convertir el buffer en una cadena hexadecimal
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex;
}
